// extracted by mini-css-extract-plugin
export var questionBox = "_6f-0";